module.exports = __webpack_public_path__ + "static/media/Assets-03-VirtualSurgery-Exhibition-hero.7903cfb4.jpg";